import { Outlet } from "react-router";
import styled from "styled-components";

import CategoryInventory from "./CategoryInventory";
import { CssSectionCard } from "../../components/styles";
import {
    useUnsavedChangesRefs,
    type UnsavedChangesContext,
} from "../../modules/unsaved-changes";

const StyledWithCategoryInventory = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 340px 1fr;
    gap: 20px;
    height: 100vh;
    overflow: hidden;
    padding: 20px;
    background: #fafbfc;

    .section-card {
        ${ CssSectionCard }
    }
`;

export type CategoryOutletContext = UnsavedChangesContext;

export default function WithCategoryInventory() {
    const guard = useUnsavedChangesRefs();

    return (
        <StyledWithCategoryInventory>
            {/* Section 1: Categories Selector */}
            <div className="section-card">
                <CategoryInventory
                    guard={ guard }
                />
            </div>
            {/* Section 2: Category Editor */}
            <div className="section-card">
                <Outlet context={ guard satisfies CategoryOutletContext } />
            </div>
        </StyledWithCategoryInventory>
    );
}
